<template>
  <div class="systemList" v-loading="loadingFlag">
    <div class="systemList-nav">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
        background-color="#BD1A2D"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>系统介绍</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1">系统介绍</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>操作指南</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1">市级手册</el-menu-item>
            <el-menu-item index="2-2">区级手册</el-menu-item>
            <el-menu-item index="2-3">校级手册</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-question"></i>
            <span>常见问题</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(item, index) in questionMenu"
              :index="item.nodeId + ''"
              :key="index"
              >{{ item.nodeName }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div v-if="defaultActive == '1-1'">
      <div style='white-space: pre-wrap;' v-html="bxtjIntroduce"></div>
    </div>
    <div v-else-if="guideArr.includes(defaultActive)" class="systemList-list">
      <pdf
        v-for="item in pageTotal"
        :src="pdfUrl"
        :key="item"
        :page="item"
        @page-loaded="pageLoaded"
      ></pdf>
    </div>
    <div class="question" v-else>
      <div class="questionBox">
        <div class="question-list">
          <div
            class="question-item"
            v-for="(item, index) in content"
            :key="index"
          >
            <div class="item-title">
              <img style="width: 18px;height: 18px;" src="@/assets/Q.svg" alt="">
             {{ index+1 }} 、{{ item.title }} -- {{ item.questionModuleName }}
            </div>
            <div style="display: flex;">
              <img  style="width: 18px;height: 18px;margin-right:5px" src="@/assets/A.svg" alt="">
              <div style='white-space: pre-wrap;' v-html="item.answer"></div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="pagination-box" v-if="pagination.total">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.pageNo"
          background
          :page-size="5"
          layout="prev, pager, next"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findCheckeIntroduceDetail,
  findCheckedBxtjGuideDetail,
  findQuestionSortTreeList,
  findCheckedBxtjQuestionPage,
} from "@/api/system";
import { getFileById } from "@/api/common";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      fileId: 0,
      bxtjIntroduce: "",
      defaultActive: "1-1",
      keyMap: {
        "2-3": "1",
        "2-2": "2",
        "2-1": "3",
      },
      pdfUrl: "",
      pageTotal: "",
      pageLoadNum: 0,
      loadingFlag: false,
      questionMenu: [],
      guideArr: ["2-1", "2-2", "2-3"],
      content: [],
      pagination: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
    };
  },
  components: {
    pdf,
  },
  mounted() {
    this.findCheckeIntroduceDetail();
    this.findQuestionSortTreeList();
  },
  methods: {
    async findCheckeIntroduceDetail() {
      const res = await findCheckeIntroduceDetail();
      this.detailsObj = res.data.detail;
      this.bxtjIntroduce = this.detailsObj.bxtjIntroduce;
    },
    async findCheckedBxtjGuideDetail(keyId) {
      const res = await findCheckedBxtjGuideDetail({ keyId });
      this.fileItem = res.data.detail;
      this.fileId = this.fileItem.attachFileId ? this.fileItem.attachFileId : 0;
      this.getFileById();
    },
    async findQuestionSortTreeList() {
      const res = await findQuestionSortTreeList({});
      this.questionMenu = res.data.listData;
    },
    async findCheckedBxtjQuestionPage(sortId) {
      const res = await findCheckedBxtjQuestionPage({
        sortId,
        pageNo: this.pagination.pageNo,
        pageSize: 5,
      });
      this.content = res.data.listData.content;
     // this.tableData = res.data.listData.content;
      this.pagination.total = res.data.listData.totalElements;
    },
    async getFileById(downFlag = 0) {
      const res = await getFileById({
        fileId: this.fileId,
        moduleFlag: "guide",
        downFlag,
      });
      console.log(this.fileId)
      const src =
        "data:application/pdf;base64," +
        btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
      this.pdfUrl = pdf.createLoadingTask(src, { withCredentials: false });
      this.pdfUrl.promise
        .then((pdf) => (this.pageTotal = pdf.numPages))
        .catch((error) => {
          console.log(error);
          this.loadingFlag = false;
        });
    },
    pageLoaded() {
      this.loadingFlag = true;

      this.pageLoadNum++;
      if (this.pageLoadNum == this.pageTotal) {
        this.loadingFlag = false;
        //console.log(this.pageLoadNum, this.pageTotal, "pageLoaded");
      }
      setTimeout(() => {
        this.loadingFlag = false;
      }, 5000);
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      //console.log(key);
      //console.log(keyPath);
      this.defaultActive = key;
      if (keyPath[0] == "1") {
        this.findCheckeIntroduceDetail();
      } else if (keyPath[0] == "2") {
        this.findCheckedBxtjGuideDetail(this.keyMap[key]);
      } else if (keyPath[0] == "3") {
        this.sortId = keyPath[1]
        this.findCheckedBxtjQuestionPage(keyPath[1]);
      }
    },
    handleCurrentChange(val){
      this.pagination.pageNo = val
      this.findCheckedBxtjQuestionPage(this.sortId );
    }
  },
};
</script>

<style lang="less" scoped>
.pagination-box {
    display: flex;
    justify-content: center;  // 将翻页器居中
    margin-top: 80px;
  }
.systemList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  //justify-content: space-between;
}
.systemList-nav {
  width: 237px;
  flex-shrink: 0;
  margin-right: 20px;
}
.systemList-list {
  flex: 1;
  min-height: 500px;
  max-height: 600px;
  overflow: hidden;
  overflow-y: auto;
}
.question{
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-height: 550px;
}
.questionBox {
  width: 100%;
  flex: 1;
  max-height: 450px;
}
.question-list {
  height: 100%;
  width: 1000px;
  overflow: hidden;
  overflow: hidden;
  overflow-y: auto;
  .question-item{
    margin-bottom: 20px;
  }
  .item-title{
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: 600;
    font-family: Microsoft YaHei;
  }
}
/deep/ .el-submenu .el-menu-item {
  background: #fff !important;
  color: #262626 !important;
}
.el-menu-item.is-active {
  background: #eee !important;
}
/deep/ .el-menu-item-group__title {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/system/index.vue